import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const {
  heading5Obj: { fontSize: heading5FontSize },
  textXSObj,
  textMObj,
  textCapsObj,
} = typographyStyles;

const uiColors = constants.colors.ui;

export const nameAndExpandContainerCss = {
  display: "flex",
  justifyContent: "space-between",
  marginBlockStart: "1.33em",
  alignItems: "start",
  marginBottom: "8px",
};

export const nameHeadingCss = {
  fontSize: heading5FontSize,
  color: colors.ui.neutral[700],
  marginBlockEnd: 0,
  marginBlockStart: 0,
  // This width is based on how much space we can leverage for the name before it
  // pushes the "replies" copy to wrap into a new line; this will prevent the copy from wrapping.
  maxWidth: "195px",
};

export const chevronIconCss = (commentIsExpanded) => ({
  width: "20px",
  position: "relative",
  transform: commentIsExpanded ? "rotate(180deg)" : null,
  transition: "transform 0.5s",
  path: {
    stroke: colors.ui.neutral[700],
  },
});

export const textCss = {
  ...textMObj,
  whiteSpace: "pre-line",
  color: colors.ui.neutral[600],
  inlineSize: "300px",
  overflowWrap: "break-word",
};

export const numberOfCommentsCss = {
  ...textXSObj,
  ...textCapsObj,
  marginRight: "4px",
  color: uiColors.neutral[700],
  marginBottom: "4px",
};

export const replyAndChevronCss = {
  display: "flex",
  alignItems: "center",
};
